<template>
    <div class="checkout">
        <Breadcrumb :crumb="crumb"></Breadcrumb>
        <div class="checkout-box">
            <div class="left">
                <div class="item-box" v-if="form_data.mtm_type == 4">
                    <div class="title">尺码数量</div>
                    <div class="size-box" v-for="(item, key) in sell_size_list">
                        <div class="size-title">{{item.name}}：</div>
                        <div class="size-wrap">
                            <div class="column">
                                <div class="cell">尺码</div>
                                <div class="cell">数量</div>
                                <div class="cell">备注</div>
                            </div>
                            <div class="column" v-for="(v, i) in item.list">
                                <div class="cell">{{v.size_value}}</div>
                                <div class="cell">
                                    <input
                                            class="input"
                                            type="text"
                                            :value="quantity_list[key].list[i].quantity"
                                            @input="update_quantity_list($event, key, i, 'quantity')"
                                    />
                                </div>
                                <div class="cell">
                                    <input
                                            class="input"
                                            type="text"
                                            :value="quantity_list[key].list[i].remark"
                                            @input="update_quantity_list($event, key, i, 'remark')"
                                    />
                                </div>
                            </div>
                            <div class="column">
                                <div class="cell">合计</div>
                                <div class="cell">{{quantity_list[key].list.map(v=>v.quantity).reduce((a,b)=>a+b)}}</div>
                                <div class="cell"></div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="item-box" v-show="!is_wnat_store">
                    <div class="title">收货地址</div>
                    <div class="address-box">
                        <div class="address-item" v-for="(item, index) in address_list" :key="index"
                             @click="choose_address(item.address_id)">
                            <div class="flex align-center ">
                                <div class="" style="width: 95%;">
                                    <span class="consignee"> {{ item.consignee}}</span>
                                    <span class="default" v-if="item.is_default"> 默认地址 </span>
                                </div>
                                <img style="width: 17px;height: 17px;"
                                     :src="getSelectImg('address_id',item.address_id)"/>
                            </div>
                            <div style="margin-top: 5px;">{{ item.mobile}}</div>
                            <div style="margin-top: 5px;">{{ item.province_name}}{{ item.city_name}}{{
                                item.zone_name}}
                            </div>
                            <div class="flex align-center justify-between">
                                <span>{{ item.address}}</span>
                                <img src="../../assets/images/user/edit@2x.png" @click.stop="edit(item)"
                                     style="width: 12px;"/>
                            </div>

                        </div>
                        <img src="../../assets/images/address-add.png" class="add" @click="open"/>
                        <div class="clear"></div>
                    </div>
                </div>
                <div class="item-box">
                    <div class="title">发货方式</div>
                    <div class="address-box">
                        <div
                                class="address-item"
                                style="height: 88px;padding: 20px 10px;"
                                v-for="(item, freight_template_id) in template_list"
                                :key="'template-'+freight_template_id"
                                @click="choose_template(freight_template_id)"
                        >
                            <div class="flex align-center justify-between">
                                <span class="consignee">{{item.name}}</span>
                                <img style="width: 17px;height: 17px;"
                                     :src="getSelectImg('template_id',freight_template_id)"/>
                            </div>
                            <div style="margin-top: 5px;">配送时间：{{item.delivery_time}}</div>
                        </div>
                        <div
                                class="address-item"
                                style="height: 88px;padding: 20px 10px;"
                                v-show="store_list.length > 0"
                                @click="want_store()"
                        >
                            <div class="flex align-center justify-between">
                                <span class="consignee">门店自提</span>
                                <img style="width: 17px;height: 17px;"
                                     :src="getSelectImg2()"/>
                            </div>
                            <div style="margin-top: 5px;"></div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>

                <div class="item-box" v-show="is_wnat_store">
                    <div class="title">门店列表</div>
                    <div class="address-box">
                        <div
                                class="address-item"
                                style="width: 300px;height: 100px;padding: 20px 10px;"
                                v-for="(item, k) in store_list"
                                :key="'store-'+item.id"
                                @click="choose_store(item.id)"
                        >
                            <div class="flex align-center justify-between">
                                <span class="consignee">{{item.name}}</span>
                                <img style="width: 17px;height: 17px;"
                                     :src="getSelectImg('store_id',item.id)"/>
                            </div>
                            <div style="margin-top: 5px;">电话：{{item.mobile}}/{{item.phone}}</div>
                            <div style="margin-top: 5px;">地址：{{item.province_name}}{{item.city_name}}{{item.zone_name}}{{item.address}}</div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>

                <div class="item-box">
                    <div class="title">客供文件</div>
                    <div class="flex align-center" style="padding: 20px 0;">
                        <div class="upload-list">
                            <div class="profile-image-wrap" v-for="(url,index) in form_data.customer_wanted" :key="'wanted-img-' + index">
                                <Icon type="ios-close-circle" class="profile-image-icon" @click="remove_customer_wanted(index)"/>
                                <img :src="url" style="width: 100px;height: 100px;"/>
                            </div>
                        </div>
                        <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess"
                                :format="['jpg','jpeg','png', 'pdf']" :max-size="10240" :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple
                                :action="uploadHost" :data="uploadData" style="display: inline-block;">
                            <img src="../../assets/images/design/add@2x.png" style="width: 100px;"/>

                        </Upload>
                    </div>

                </div>

                <div class="item-box">
                    <div class="title">订单备注</div>
                    <textarea class="remark" @input="update_remark" placeholder="请写上您的备注">{{remark}}</textarea>
                </div>
                <div class="tips">说明：随着定制内容、数量、制版都会影响发货时间，请耐心等待，如有疑问请联系客服。</div>
            </div>
            <div class="right">
                <div class="title">订单确认</div>
                <div class="goods">
                    <img :src="this.$store.state.mtm.effect_picture || category.main_image"/>
                    <div class="content">
                        <div class="p-name">{{category.category_name_cn}}</div>
                        <div class="number-box" v-show="form_data.mtm_type != 4">
                            <div class="minus" @click="minus">-</div>
                            <input class="num" type="text" @input="update_quantity" :value="quantity"/>
                            <div class="plus" @click="plus">+</div>
                        </div>
                    </div>
                </div>
                <div class="order">
                    <template v-for="(item,index) in price_detail">
                        <div class="item" :key="item.code">
                            <span>{{item.title}}</span>
                            <span class="price">{{item.total.toFixed(2)}}</span>
                        </div>
                    </template>
                </div>
                <div class="total">
                    <span>合计</span>
                    <span class="price">{{price_total|price_format}}</span>
                </div>
                <div class="pay" @click="submit">确认订单</div>
            </div>
        </div>

        <Address :show="is_show" :item="addressItem" @cancel="cancel" @addAddress="add"/>

        <Modal
                :value="is_checkout"
                :closable="false"
                :mask-closable="false"
                :footer-hide="true"
                width="360"
                :styles="{top: '400px'}"
                class-name="hailin-ivu-modal-wrap"
        >
            <p slot="header" class="ivu-modal-header">
                <span>确认订单</span>
            </p>
            <div class="flex align-center justify-around">
                <div class="btn btn-another" @click="go2another">再下一单</div>
                <div class="btn btn-pay" @click="go2pay">立即支付</div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {debounce, throttle} from 'lodash'
    import C from "@/utils/constant"
    import tools3d from "@/utils/3d_tools"
    import {oss} from '@/utils/aliyunoss.js'
    import axios from 'axios'
    import {mapState} from 'vuex'
    import Breadcrumb from "@/components/Breadcrumb.vue";
    import Address from "@/components/Address.vue";
    import {myAddressList, MEstimate, MDeliveryTemplate, MDeliveryTime, MSubmit, MPicture, uploadOss, getStoreList, uploadFile} from "@/api"
    export default {
        name: "Checkout",
        components: {
            Breadcrumb,
            Address,
        },
        data() {
            return {
                crumb: [{
                    title: "确认订单",
                    path: "Checkout",
                },],
                is_show: false,
                is_checkout: false,
                addressItem: {},
                address_list: [],
                available_template_list: [],
                warehouse_times: [],
                price_detail: [],
                is_submit: false,
                store_list: [],
                is_wnat_store: false,
                uploadHost: '',
                uploadData: {},
            };
        },
        computed: {
            ...mapState({
                category: (state) => state.mtm.picked_category,
                address_id: (state) => state.mtm.form_data.address_id,
                template_id: (state) => state.mtm.form_data.template_id,
                store_id: (state) => state.mtm.form_data.store_id,
                remark: (state) => state.mtm.form_data.remark,
                quantity: (state) => state.mtm.form_data.quantity,
                form_data: (state) => state.mtm.form_data,
                sell_size_list: (state) => state.mtm.picked_category.size_group_data,
                quantity_list: (state) => state.mtm.form_data.quantity_list,
            }),
            template_list() {
                let object = {}
                this.available_template_list.forEach((elem, idx) => {
                    let warehouse = this.warehouse_times.find((v) => {
                        return v.template_id === elem.id
                    })
                    if (warehouse?.is_match) {
                        object[elem.id] = {
                            name: elem.freight_template_name,
                            min: warehouse.min,
                            max: warehouse.max,
                            delivery_time: `${warehouse.min}~${warehouse.max}天`,
                            is_available: true,
                        }
                    } else {
                        object[elem.id] = {
                            name: elem.freight_template_name,
                            min: 0,
                            max: 0,
                            delivery_time: `暂无配送`,
                            is_available: false,
                        }
                    }
                })
                return object
            },
            price_total() {
                return this.price_detail.map(v=>v.total).reduce((a,b)=>a+b, 0)
            },
        },
        watch: {
            address_id: {
                handler: function (val, oldVal) {
                    this.$store.commit('mtm/choose_template', 0)
                    this.calculate_delivery_time().then(() => {
                        let first_available_template_id = 0;
                        for (let template_id in this.template_list) {
                            if (true === this.template_list[template_id].is_available) {
                                first_available_template_id = template_id;
                                break;
                            }
                        }
                        return this.choose_template(first_available_template_id)
                    })
                },
                // immediate: true
            },
            store_id: {
                handler: function (val, oldVal) {
                    if (val === 0) {
                        this.is_wnat_store = false
                        return
                    }
                    this.is_wnat_store = true
                },
                immediate: true
            },
            template_id: {
                handler: function (val, oldVal) {
                    if (val === 0) {
                        return
                    }
                    this.preview()
                },
                // immediate: true
            },
            quantity: {
                handler: function (val, oldVal) {
                    if (val === 0) {
                        return
                    }
                    this.preview()
                },
                // immediate: true
            },
            'form_data.quantity_list': {
                deep: true,
                handler: function (val, oldVal) {
                    if (val === 0) {
                        return
                    }
                    this.preview()
                },
            }
        },
        methods: {
            async getAddressList() {
                return await myAddressList().then((res) => {
                    this.address_list = res.data
                })
            },
            go2another() {
                this.is_checkout = false
                this.$nextTick(() => {
                    this.$router.push({name: 'Home'})
                })
            },
            go2pay() {
                this.is_checkout = false
                this.$nextTick(() => {
                    this.$router.replace({name: 'Paytype'})
                })
            },
            open() {
                this.addressItem = {}
                this.is_show = true;
            },
            edit(item) {
                this.addressItem = item
                this.is_show = true;
            },
            add() {
                this.is_show = false;
                this.getAddressList()
            },
            cancel() {
                this.is_show = false;
            },
            minus() {
                if (this.quantity <= 0) return
                this.$store.commit('mtm/update_quantity', this.quantity - 1)
            },
            plus() {
                this.$store.commit('mtm/update_quantity', this.quantity + 1)
            },
            update_quantity(e) {
                this.$store.commit('mtm/update_quantity', e.target.value)
            },
            update_remark(e) {
                this.$store.commit('mtm/update_remark', e.target.value)
            },
            choose_address(id) {
                this.$store.commit('mtm/choose_address', id)
            },
            choose_template(id) {
                if (!this.template_list[id]?.is_available) {
                    this.$store.commit('mtm/choose_template', 0)
                    if(this.store_id==0) {
                        this.$Notice.error({
                            title: "暂无配送"
                        })
                    }

                    return
                }
                this.$store.commit('mtm/choose_template', id)
                this.$store.commit('mtm/update_common', {
                    key: 'store_id',
                    value: 0
                })
                this.is_wnat_store = false
            },
            choose_store(id) {
                this.$store.commit('mtm/update_common', {
                    key: 'store_id',
                    value: id
                })
            },
            want_store() {
                this.is_wnat_store = true
                this.$store.commit('mtm/choose_template', 0)
            },
            calculate_delivery_time() {
                if (this.address_id <= 0)
                    return
                return MDeliveryTime({
                    address_id: this.address_id,
                    templates: JSON.stringify(Object.keys(this.template_list)),
                    type: "mtm"
                }).then(result => {
                    this.warehouse_times = result.data
                    // this.preview()
                })
            },
            preview() {
                MEstimate({...this.form_data}).then(response => {
                    this.price_detail = response.data
                })
            },
            debounce_submit: debounce(function () {
                this.is_submit = true;
                new Promise(async (resolve, reject) => {
                    let result = await MSubmit({...this.form_data})
                    this.$Message.info("订单已生成~");
                    resolve(result.data.order_id)
                }).then(() => {
                    this.is_checkout = true
                }).catch(err => {
                    this.is_submit = false
                    this.$Notice.error({
                        title: err.msg
                    })
                })
            }, 300),
            submit() {
                if (this.is_submit) {
                    this.$Message.info("请勿重复提交~");
                    return
                }
                this.debounce_submit()
            },
            getSelectImg(key, id) {
                return this[key] === id ? require('@/assets/images/select.png') : require('@/assets/images/no-select.png')
            },
            getSelectImg2() {
                return this.is_wnat_store ? require('@/assets/images/select.png') : require('@/assets/images/no-select.png')
            },
            update_quantity_list(e, k, i, field) {
                let value = parseInt(e.target.value)
                if(field === 'quantity' && isNaN(value)) {
                    value = 0
                }
                this.$store.commit('mtm/update_quantity_list', {
                    k,
                    i,
                    field,
                    value
                })
            },
            remove_customer_wanted(index) {
                this.$store.commit('mtm/remove_customer_wanted', index)
            },
            handleSuccess(res, file) {
                this.$store.commit('mtm/add_customer_wanted', this.uploadData.oss_url + this.uploadData.dir + file.name)
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: '文件格式不正确',
                    desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '超出文件大小限制',
                    desc: '文件 ' + file.name + ' 太大，不能超过 10M。'
                });
            },
            handleBeforeUpload(file) {
                //console.log(file,"file.name")
                return oss(file.name).then(res => {
                    this.uploadHost = res.host
                    this.uploadData = res
                })
            },
        },
        created() {
            getStoreList().then((response) => {
                this.store_list = response.data
            })
            axios.all([
                MDeliveryTemplate({type: 'mtm'}),
                myAddressList(),
            ]).then(axios.spread((response1, response2) => {
                this.available_template_list = response1.data
                this.address_list = response2.data
            })).then(() => {
                if (this.address_id) {
                    this.calculate_delivery_time().then(() => {
                        return this.choose_template(this.template_id)
                    })
                } else {
                    let default_address = this.address_list.find((elem, key) => {
                        return elem.is_default === 1
                    })
                    this.choose_address(default_address ? default_address.address_id : 0);
                }
            }).then(() => {
                this.preview()
            })
        },
        mounted() {
            this.$emit('showLogin', true)
            this.$emit('showBack', false)
            this.$emit('showNav', true)
            this.$emit('showFooter', true)
        },
    };
</script>

<style lang="scss">
    .checkout {
        width: 1170px;
        margin: 20px auto;

        .checkout-box {
            display: flex;

            .left {
                .item-box {
                    width: 870px;
                    background: #ffffff;
                    box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
                    border-radius: 5px;
                    margin-top: 20px;
                    padding: 0px 20px 20px;

                    .title {
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        line-height: 22px;
                        color: #0f114a;
                        height: 52px;
                        line-height: 52px;
                        border-bottom: 1px solid #e9e9e9;
                    }

                    .address-box {

                        .address-item:nth-child(4n) {
                            margin-right: 0px;
                        }

                        .address-item {
                            width: 200px;
                            height: 100px;
                            background: #F5F5F5;
                            border-radius: 4px;
                            float: left;
                            margin-top: 20px;
                            margin-right: 10px;
                            padding: 10px;
                            color: #333333;
                            font-size: 12px;

                            .consignee {
                                font-weight: bold;
                                font-size: 15px;
                            }

                            .default {
                                font-weight: bold;
                                font-size: 12px;
                                color: #0F114A;
                                margin-left: 5px;
                            }
                        }

                        .add {
                            width: 200px;
                            height: 102px;
                            float: left;
                            margin-top: 20px;
                        }
                    }

                    .size-box {

                        .size-title {
                            padding: 10px 0;
                            color: #333;
                            font-size: 15px;
                        }
                        .size-wrap {
                            display: flex;
                            justify-content: flex-start;
                            flex-wrap: wrap;

                            .column {
                                display: flex;
                                flex-wrap: wrap;
                                width: 80px;
                                color: #333;

                                .cell {
                                    width: 100%;
                                    height: 44px;
                                    line-height: 44px;
                                    text-align: center;
                                    border: 1px solid #eee;

                                    .input {
                                        max-width: 74px;
                                        height: 34px;
                                        text-align: center;
                                        border: 1px solid #999;
                                        box-sizing: border-box;
                                        padding: 0 5px;
                                    }
                                    &:first-child {
                                        background: #F8F8F8;
                                    }
                                }
                                &:first-child{
                                    font-weight: bold;
                                    background: #F8F8F8;
                                }
                                &:last-child {
                                    color: #0F114A;
                                    font-size: 15px;
                                    font-weight: bold;
                                }
                            }
                        }

                    }


                    .remark {
                        width: 830px;
                        height: 80px;
                        background: #f3f4f5;
                        opacity: 1;
                        border-radius: 5px;
                        border: none;
                        padding: 10px;
                        margin-top: 20px;
                    }
                }

                .tips {
                    margin: 30px 0;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 22px;
                    color: #666666;
                    text-align: center;
                }
            }

            .right {
                margin-top: 20px;
                margin-left: 30px;
                width: 270px;
                height: 442px;
                background: #ffffff;
                box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
                padding: 0 20px;

                .title {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 22px;
                    color: #000000;
                    height: 52px;
                    line-height: 52px;
                    border-bottom: 1px solid #e9e9e9;
                    text-align: center;
                }

                .goods {
                    padding: 10px 0 30px;
                    display: flex;

                    img {
                        width: 80px;
                        height: 80px;
                    }

                    .content {
                        margin-left: 10px;

                        .p-name {
                            font-size: 15px;
                            font-weight: bold;
                            color: #000000;
                            height: 60px;
                        }

                        .number-box {
                            height: 20px;
                            border: 1px solid #999999;
                            display: flex;
                            align-items: center;

                            .minus,
                            .plus {
                                width: 27px;
                                cursor: pointer;
                                color: #707070;
                                line-height: 27px;
                                text-align: center;
                                font-size: 18px;
                            }

                            .num {
                                border-top: none;
                                border-bottom: none;
                                border-left: 1px solid #999999;
                                border-right: 1px solid #999999;
                                width: 27px;
                                text-align: center;
                                color: #000000;
                            }
                        }
                    }
                }

                .order {
                    border-bottom: 1px solid #dddddd;
                    padding-bottom: 10px;

                    .item {
                        margin-top: 10px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        span {
                            font-size: 13px;
                            font-weight: bold;
                            color: #333333;
                        }

                        .price {
                            font-weight: 400;
                            color: #666666;
                        }
                    }
                }

                .total {
                    height: 44px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    span {
                        font-size: 15px;
                        font-weight: bold;
                        color: #333333;
                    }

                    .price {
                        font-weight: 400;
                        color: #0f114a;
                    }
                }

                .pay {
                    width: 230px;
                    height: 44px;
                    line-height: 44px;
                    background: #0f114a;
                    opacity: 1;
                    border-radius: 2px;
                    text-align: center;
                    font-size: 16px;
                    font-weight: bold;
                    color: #edd4ac;
                    text-align: center;
                    margin-top: 30px;
                    cursor: pointer;
                }
            }
        }
    }

    .hailin-ivu-modal-wrap {
        .ivu-modal-header {
            width: 360px;
        }

        .btn {
            width: 155px;
            height: 44px;
            line-height: 44px;
            font-size: 16px;
            text-align: center;
            margin: 44px 0 34px 0;
            border-radius: 4px;
            font-weight: bold;

            &.btn-another {
                background: rgb(255, 255, 255);
                border: 1px solid #0F114A;
                color: #0F114A;
            }

            &.btn-pay {
                background: rgb(15, 17, 74);
                color: #EDD4AC;
            }
        }
    }

    .upload-list {
        display: inline-block;
        margin-right: 10px;

        .profile-image-wrap {
            display: inline-block;
            position: relative;

            .profile-image-icon {
                position: absolute;
                top: -10px;
                right: 0;
                font-size: 20px;
                z-index: 100;
            }
        }

        img {
            margin: 0 10px;
        }
    }

</style>
